export const successElement = [
    document.querySelector('.visit-success') as HTMLDivElement, 
    document.querySelector('.recommend-success') as HTMLDivElement,
    document.querySelector('.success-testimonyStep') as HTMLDivElement,
]